/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { ON_PROGRESS_DATA,SET_RECONCILE_DATA,SET_CLEAR_DATA, SET_PREPAREGSTR9_DATA,SET_RECONCILE_HISTORY,LOADER_STATUS,SET_TOTAL_RECORD,PROFILE_INFO,SET_AUTO_POPULATED_HISTORY,SET_HSN_DATA, SET_AUTODRAFTED_HISTORY} from './constants';

// The initial state of the App
export const initialState = {
  progressData: [],
  loaderStatus: false,
  totalRecord:'',
  profileData:[],
  autoPopulatedHistory:[],
  draftedData:'',
  reconcileInfoData:'',
  reconcileHistoryData:'',
  prepareSummaryData:{}
};


/* eslint-disable default-case, no-param-reassign */
const uploadedDataReducergstr9 = (state = initialState, action) =>{
    switch (action.type) {
      case ON_PROGRESS_DATA:
        return {
          ...state,
          progressData:action.progressData
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_TOTAL_RECORD:
        return {
          ...state,
          totalRecord:action.totalRecord
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SET_AUTO_POPULATED_HISTORY:
        return {
          ...state,
          autoPopulatedHistory:action.payload
        }
      case SET_AUTODRAFTED_HISTORY:
        return {
          ...state,
          draftedData:action.draftedData
        }
      case SET_RECONCILE_DATA:
        return {
          ...state,
          reconcileInfoData:action.payload
        }
      case SET_RECONCILE_HISTORY:
        return {
          ...state,
          reconcileHistoryData:action.payload
        }
      case SET_PREPAREGSTR9_DATA:
        return {
          ...state,
          prepareSummaryData:action.payload
        }
        case SET_CLEAR_DATA:
          return {
            ...state,
            prepareSummaryData:{},
            reconcileInfoData:"",
            reconcileInfoData:"",
            draftedData:""

          }
        default:
          return state;
    }
  };

export default uploadedDataReducergstr9;
